export const AUCTION_WON_NOTIFICATION_DISPLAY_KEY = 'auctionWonNotificationDisplayed';
